import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import '../styles/FeaturedEvents.scss';
import Title from './common/Title';
import SliderNavigation from './common/SliderNavigation';

const FeaturedEventsSkeleton = () => {
  return (
    <section className="featured-events">
      <Title text="FEATURED EVENTS" />

      <div className="carousel-wrapper">
        <SliderNavigation
          onPrevClick={() => {}}
          onNextClick={() => {}}
          canPrev={false}
          canNext={false}
        />

        <div className="carousel-container">
          <div className="slider-container">
            <div className="events-track">
              {Array.from({ length: 3 }).map((_, idx) => (
                <div className="event-card" key={idx}>
                  <div className="image-container">
                    <Skeleton height={200} width="100%" />
                  </div>

                  <div className="content">
                    <Skeleton width="90%" height={25} />
                    <Skeleton width="70%" height={20} />
                    <Skeleton width="60%" height={15} />
                    <div className="datetime">
                      <Skeleton width={100} height={15} />
                      <Skeleton width={80} height={15} />
                    </div>
                    <Skeleton width={100} height={30} />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedEventsSkeleton;
